import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import BackToTop from "../components/BackToTop";
import { fetchAllNews } from "../api/newsApi";
import "../css/NewsPage.css";

const CalendarIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
    <line x1="16" y1="2" x2="16" y2="6" />
    <line x1="8" y1="2" x2="8" y2="6" />
    <line x1="3" y1="10" x2="21" y2="10" />
  </svg>
);

const NewsCard = ({ item }) => {
  const [hovered, setHovered] = useState(false);
  const [imgError, setImgError] = useState(false);
  const [imgLoaded, setImgLoaded] = useState(false);

  const slug = item.Slug;
  const title = item.Title;
  const date = item.Date;
  const mainImage = item.MainImage;

  return (
    <Link
      to={`/news/${slug}`}
      className="news-card"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        transform: hovered ? "translateY(-4px)" : "translateY(0)",
        boxShadow: hovered
          ? "0 12px 40px rgba(0,0,0,0.13)"
          : "0 2px 12px rgba(0,0,0,0.06)",
      }}
    >
      <div className="news-card-image">
        {mainImage && !imgError ? (
          <>
            {!imgLoaded && <div className="news-card-skeleton" />}
            <img
              src={mainImage}
              alt={title}
              style={{
                transform: hovered ? "scale(1.04)" : "scale(1)",
                display: imgLoaded ? "block" : "none",
              }}
              onLoad={() => setImgLoaded(true)}
              onError={() => setImgError(true)}
            />
          </>
        ) : (
          <div className="news-card-placeholder">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#a0aec0" strokeWidth="1">
              <rect x="3" y="3" width="18" height="18" rx="2" />
              <circle cx="8.5" cy="8.5" r="1.5" />
              <polyline points="21 15 16 10 5 21" />
            </svg>
          </div>
        )}
      </div>
      <div className="news-card-content">
        <h3 className="news-card-title">{title}</h3>
        <div className="news-card-date">
          <CalendarIcon />
          {date}
        </div>
      </div>
    </Link>
  );
};

const NewsPage = () => {
  const [newsItems, setNewsItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadNews = async () => {
      try {
        const data = await fetchAllNews();
        setNewsItems(data);
      } catch (err) {
        console.error(err);
        setError("Failed to load news. Please try again later.");
      } finally {
        setLoading(false);
      }
    };
    loadNews();
  }, []);

  if (loading) return <div className="loading-spinner">Loading news...</div>;
  if (error) return <div className="error-message">{error}</div>;

  return (
    <>
      <Header />
      <div className="news-page">
        <div className="news-breadcrumb">
          <span>
            <a href="/">Home</a> <span className="separator">&gt;</span>{" "}
            <span className="current">News</span>
          </span>
        </div>
        <div className="news-container">
          <div className="news-grid">
            {newsItems.map((item) => (
              <NewsCard key={item.Id} item={item} />
            ))}
          </div>
        </div>
      </div>
      <BackToTop />
      <Footer />
    </>
  );
};

export default NewsPage;